import React from "react";
import { Redirect } from "react-router-dom";

import { useCmrAuth } from "state/CMRAuth";
import cmrLogoColour from "ui/resources/logos/cmr_colour.png";

import "./LoginPage.css";
import RoutesName from "routes/routesName";

const LoginPage: React.FC = () => {
    const { user, signIn } = useCmrAuth();

    if (user) return <Redirect to={RoutesName.newOrLoad} />;
    return (
        <div className="login-section">
            <div className="background-image">
                <div className="blur" />
            </div>

            <div className="login-area">
                <img className="login-logo" alt="CMR Logo" src={cmrLogoColour} />
                <span className="login-title">CMR</span>
                <button
                    id="login-button"
                    type="button"
                    className="login-button primary-button"
                    onClick={signIn}
                >
                    Sign In
                </button>
            </div>
        </div>
    );
};

export default LoginPage;
